import React from "react";
import FourColumnRowSection from "components/common/FourColumnRowSection/FourColumnRowSection";
import { Field } from "../Field/Field";
import { Typography } from "antd";
import { CustomerRules } from "utils/formRules";
import { ImagePayload } from "types/image.type";

const { Text } = Typography;

interface DependentPerson {
  id: string;
  fullName: string;
  relationship: string;
  birthDate: string;
  gender: string;
  idCard: string;
  idIssueDate: string;
  idIssuePlace: string;
  taxCode: string;
  image?: string;
}

interface DependentEditSectionProps {
  index: number;
  data: DependentPerson;
  onUpdate: (path: string, value: string | number | boolean | undefined | ImagePayload[]) => void;
  onRemove: (id: string) => void;
  handleUpload?: (file: File, path: string) => void;
  isUploading?: boolean;
}

export const DependentEditSection: React.FC<DependentEditSectionProps> = ({
  index,
  data,
  onUpdate,
}) => {
  const basePath = `dependents.${index}`;

  return (
    <div className="relative group flex items-start gap-4 mb-6">
      <div className="flex-grow">
        <FourColumnRowSection
          leftTitle={
            <div className="flex items-center gap-14 min-w-[500px]">
              <div className="w-[200px]">
                <Field
                path={`${basePath}.fullName`}
                value={data.fullName}
                onUpdate={onUpdate}
                placeholder="Nhập họ tên NPT"
                rules={CustomerRules}
              />
              </div>
              <div className="flex items-center gap-2 min-w-[200px]">
                <Text className="text-gray-500 whitespace-nowrap">
                  Quan hệ:
                </Text>
                <Field
                  path={`${basePath}.relationship`}
                  value={data.relationship}
                  onUpdate={onUpdate}
                  options={["Cha", "Mẹ", "Vợ", "Chồng", "Con"]}
                  placeholder="Chọn quan hệ"
                />
              </div>
            </div>
          }
          rightTitle=""
          rows={[
            {
              leftLabel: "Ngày sinh",
              leftValue: (
                <Field
                  type="date"
                  path={`${basePath}.birthDate`}
                  value={data.birthDate}
                  onUpdate={onUpdate}
                  placeholder="Chọn ngày sinh"
                  rules={CustomerRules}
                />
              ),
              rightLabel: "Giới tính",
              rightValue: (
                <Field
                  path={`${basePath}.gender`}
                  value={data.gender}
                  onUpdate={onUpdate}
                  options={["Nam", "Nữ"]}
                  rules={CustomerRules}
                />
              ),
            },
            {
              leftLabel: "Số CCCD/CMND",
              leftValue: (
                <Field
                  path={`${basePath}.idCard`}
                  value={data.idCard}
                  onUpdate={onUpdate}
                  placeholder="Nhập số CCCD/CMND"
                  rules={CustomerRules}
                />
              ),
              rightLabel: "Ngày cấp",
              rightValue: (
                <Field
                  type="date"
                  path={`${basePath}.idIssueDate`}
                  value={data.idIssueDate}
                  onUpdate={onUpdate}
                  placeholder="Chọn ngày cấp"
                />
              ),
            },
            {
              leftLabel: "Nơi cấp",
              leftValue: (
                <Field
                  path={`${basePath}.idIssuePlace`}
                  value={data.idIssuePlace}
                  onUpdate={onUpdate}
                  placeholder="Nhập nơi cấp"
                />
              ),
              rightLabel: "Mã số thuế cá nhân NPT",
              rightValue: (
                <Field
                  path={`${basePath}.taxCode`}
                  value={data.taxCode}
                  onUpdate={onUpdate}
                  placeholder="Nhập mã số thuế"
                />
              ),
            },
            {
              leftLabel: "Ảnh chứng từ",
              leftValue: (
                // 
                ""
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};
